import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchContractLanguageQuery,
  Flex_FetchContractLanguageQueryVariables,
} from '~/typings/graphql';
import { FETCH_CONTRACT_LANGUAGE } from './fetch-contract-version-language.queries';

export type FetchContractLanguageParams = {
  contractVersionId: number;
  languageShortCode: string;
};

export type FetchContractLanguageResponse = {
  id: number;
  contractVersionLanguage?: { id: number } | null;
};

export const fetchContractVersionLanguage = async (
  params: FetchContractLanguageParams,
): Promise<FetchContractLanguageResponse> => {
  const { contractVersionId, languageShortCode } = params;
  const { data } = await apolloClient.query<
    Flex_FetchContractLanguageQuery,
    Flex_FetchContractLanguageQueryVariables
  >({
    query: FETCH_CONTRACT_LANGUAGE,
    variables: {
      contractVersionId,
      languageShortCode,
    },
  });
  return data.contractVersion;
};
